<template>
  <div class="ui container">
    <div class="ui left aligned">
      <div class="ui form">
        <div class="inline fields">
          <div class="field">
            <label>艺人</label>
            <select v-model="starId" @change="load()">
              <option value=""></option>
              <option value="杨超越">杨超越</option>
              <option value="李宇春">李宇春</option>
              <option value="张碧晨">张碧晨</option>
              <option value="吴秀波">吴秀波</option>
              <option value="罗云熙">罗云熙</option>
              <option value="唐嫣">唐嫣</option>
              <option value="倪妮">倪妮</option>
              <option value="秦岚">秦岚</option>
              <option value="杨洋">杨洋</option>
              <option value="张杰">张杰</option>
              <option value="陈坤">陈坤</option>
              <option value="迪丽热巴">迪丽热巴</option>
            </select>
          </div>
          <a href="http://news.qq.com/zt2018/cwei/app.htm?listid=17" target="_blank">活动时间： 12月10日10点-12月15日00点</a>
          <button @click="refresh()" class="ui primary mini button" id="refresh"><i class="sync icon"></i></button>
        </div>
      </div>

      <vuetable ref="vuetable"
                :api-url="'/news/' + starId"
                :fields="fields"
                :sort-order="sortOrder"
                :perPage="12"
                @vuetable:pagination-data="onPaginationData"
      >
      </vuetable>
      <div class="ui grid">
        <div class="ui left aligned six wide column">
          <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
        </div>
        <div class="right floated six wide column">
          <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
        </div>
      </div>
    </div>
    <div class="ui hidden divider"></div>
    <div class="ui form">
      <div class="inline fields">
        <label>间隔</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="5" v-model="interval" @change="load()">
            <label>5分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="15" v-model="interval" @change="load()">
            <label>15分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="30" v-model="interval" @change="load()">
            <label>30分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="60" v-model="interval" @change="load()">
            <label>1小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="180" v-model="interval" @change="load()">
            <label>3小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="360" v-model="interval" @change="load()">
            <label>6小时</label>
          </div>
        </div>
      </div>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style scoped>
  .form {
    padding-top: 15px;
  }

  #refresh {
    margin-left: 24px;
  }
  @media screen and (min-width:960px) {
    #chart {
      width: 900px;
      height: 400px;
    }
  }
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import VuetablePaginationInfo from '../table/VuetablePaginationInfo.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'

  export default {
    name: 'News',
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
      'v-chart': ECharts
    },
    data () {
      return {
        starId: "",
        interval: 5,
        fields: [
          {name: 'rank', title: '排名'},
          {name: 'name', title: '姓名'},
          {name: 'count', title: '票数'},
          {name: 'inc', title: '差值'},
          {name: 'time', title: '时间', callback: 'date'},
        ],
        sortOrder: [
          {
            field: 'time',
            direction: 'desc'
          }
        ],
        options: null
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
        refresh: function () {
            this.$refs.vuetable.reload();
            this.load();
        },
      load: function () {
        axios.get('/news/chart/' + this.starId + '?interval=' + this.interval).then(data => {
          let series = [];
          let legend = [];
          for (let item of data.data) {
            let name = item[0].name;
            series.push({
              name: name,
              type: 'line',
              data: item.map(e => [e.time, e.inc])
            });
            legend.push(name);
          }
          this.options =
              {
                title: {
                  text: '走势图'
                },
                legend: {
                  data: legend
                },
                tooltip: {
                  trigger: 'axis'
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: series
              };
        });
      },
      date: function (value) {
        let date = new Date(value);
        return date.toLocaleString();
      }
    }
  }
</script>
